export default __webpack_public_path__ + "static/media/ic_cap_up.c662db5e.svg";